import { z } from "zod";

/**
 * Validation schemas for the auth screens. Kept in the feature (not the page)
 * so the same rules back the form, tests, and any future programmatic callers.
 */
export const loginSchema = z.object({
  username: z.string().min(1, "Username is required"),
  password: z.string().min(1, "Password is required"),
  rememberMe: z.boolean(),
});
export type LoginValues = z.infer<typeof loginSchema>;

/** Signup form. Field names match the backend payload (sent as-is). Captcha is
 * optional here and enforced by the form only when the site requires it. */
export const signupSchema = z
  .object({
    fname: z.string().min(2, "Enter your first name"),
    lname: z.string().min(2, "Enter your last name"),
    email: z.string().min(1, "Email is required").email("Enter a valid email"),
    username: z.string().min(3, "Use at least 3 characters"),
    phone: z.string().regex(/^[0-9+\-\s()]{6,}$/, "Enter a valid phone number"),
    password: z
      .string()
      .min(6, "Use 6–20 characters")
      .max(20, "Use 6–20 characters"),
    confirmpassword: z.string().min(1, "Confirm your password"),
    country_id: z.string().min(1, "Select your country"),
    captcha: z.string().optional(),
    newsletter: z.boolean(),
  })
  .refine((values) => values.password === values.confirmpassword, {
    message: "Passwords don't match",
    path: ["confirmpassword"],
  });
export type SignupValues = z.infer<typeof signupSchema>;
